const state = {
    reward: "",
    partner_login: null,
}

const mutations = {
    SET_PARTNER_REWARD(state, payload) {
        state.reward = payload;
    },
    SET_PARTNER_LOGIN(state, payload) {
        state.partner_login = payload;
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
};